import React from 'react';
import { MiniPanel } from '@cgn/framework-ui-components/v2';

export default function AvvisoContenutoEsclusivoPianoNonAttivo() {
  return (
    <MiniPanel
      position="right"
      type="warning"
      message={(
        <p className="modaleQuesito__paragrofo_info">
          Funzione non presente nel tuo attuale Piano Qualità. Attiva il Piano Eccellenza per utilizzarla.
        </p>
      )}
    />
  );
}
